<template>
  <div class="container" style="background: linear-gradient(180deg, #E9EFF5 0%, #E4EEFA 100%)">
    <div class="title">
      <div class="title-center">{{ formDate.name }}</div>
      <div class="equipment">
        <img src="../assets/img/start-top.png" alt="">
        <span>{{ formDate.state === 1 ? 'Run' : formDate.state === 0 ? 'Stare Up' : 'Stop' }}</span>
      </div>
<!--      <div class="time">-->
<!--        <img src="../assets/img/time-top.png" alt="">-->
<!--        <span>{{ nowDateList }}&nbsp;&nbsp;&nbsp; {{ nowDate }}</span>-->
<!--        &lt;!&ndash;   {{ nowDateWeek }}     &ndash;&gt;-->
<!--      </div>-->
    </div>

    <div class="content-box" >
      <div class="left">
        <div class="title">Printing Speed (sheets/hour)</div>
        <div class="value">{{ serialData === "等待串口数据…" ? '--' : serialData }}<span style="font-size: 40px">SPH</span></div>
      </div>
      <div class="right">
        <div class="right-top">
          <div class="right-item">
            <img src="@/assets/img/icon-c.png" alt="">
            <span>Conductivity:</span>
            <span class="value">{{ Number(formDate.ddl) > 0 ? formDate.ddl : '--' }}</span>
          </div>
          <div class="right-item">
            <img src="@/assets/img/icon-ph.png" alt="">
            <span class="ph">PH Value:</span>
            <span class="value">{{ Number(formDate.ph) > 0 ? formDate.ph : '--' }}</span>
          </div>
          <div class="right-item">
            <img src="@/assets/img/icon-t.png" alt="">
            <span>Temperature:</span>
            <span class="value">{{ Number(formDate.wd) > 0 ? formDate.wd : '--'}}</span>
          </div>
        </div>
        <div class="right-top">
          <div class="right-item">
            <img src="@/assets/img/icon-number.png" alt="">
            <span>Total Sheets:</span>
            <span class="value">{{ dayPrintCount }}</span>
          </div>
          <div class="right-item">
            <img src="@/assets/img/icon-item.png" alt="">
            <span>Prod.Hours:</span>
            <span class="value">{{ formDate.time }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import API from "@/api";

export default {
  name: "dataMonitorEquipment.vue",
  data() {
    return {
      nowDate:'',
      nowDateList: '',
      nowDateWeek: '',
      //deviceId
      formDate: {
        conductivity: 0,
        ph: 0,
        temperature: 0,
        ddl: '',
        wd: '',
        speed: '',
        printCount: '',
        time:'',
        chanNengOee: '',
        timeOee: '',
        name:'',
        state:0
      },
      serialData: '等待串口数据…',
      serialDataC: '等待串口数据…',
      // 新增：串口超时计时器
      serialTimeoutTimer: null,
      serverVersion:1,
      timerData: null,   // 接口刷新定时器
      baseAllCount: 0, // 新增：接口返回的基准总数
      // 保存上一次有效 c 值
      lastValidC: null,
    }
  },
  mounted() {
    window.onSerialData = this.handler
    this.timerData = setInterval(() => {
      this.DaPingVersion()
    }, 1000 * 20) // 10 秒
  },
  beforeDestroy() {
    delete window.onSerialData
    clearInterval(this.timerData)
    // 清除串口超时计时器
    if (this.serialTimeoutTimer) {
      clearTimeout(this.serialTimeoutTimer)
    }
  },
  created() {
    this.currentTime()
    this.getFormDate()
    this.currentTime2()
  },
  computed: {
    // 日印刷数
    dayPrintCount() {
      const v = Number(this.serialDataC)
      if (isNaN(v) || this.serialDataC === '等待串口数据…') {
        return this.formDate.count
      }
      // 超过上限后，保持最后一次有效值，不再变化
      // if (this.cLocked) {
      //   return Math.max(0, v - this.baseAllCount)
      // }
      return Math.max(0, v - this.baseAllCount)
    },
  },
  methods: {
    handler(payload) {
      // 清除之前的超时计时器
      if (this.serialTimeoutTimer) {
        clearTimeout(this.serialTimeoutTimer)
      }

      let item
      // 判断是数组取最后一项；是对象直接用；其它直接返回
      if (Array.isArray(payload)) {
        if (payload.length === 0) return
        item = payload.at(-1)
      } else {
        item = payload
      }

      // 防御：item不存在或者没有v/c字段直接退出
      if (!item || item.v === undefined || item.c === undefined) {
        return
      }

      const v = Number(item.v) // 速度
      if (v <= 99999) {
        this.serialData = item.v
      }
      const currentC = Number(item.c) // 日印刷数

      // ===================== 核心跳变校验逻辑不变 =====================
      if (!isNaN(currentC)) {
        if (this.lastValidC == null) {
          // 第一次：直接赋值
          this.serialDataC = currentC
          this.lastValidC = currentC
        } else {
          // 比上次大100倍或者变小，丢弃
          if (currentC >= this.lastValidC * 100 || currentC < this.lastValidC) {
            console.log('数据异常（跳变/减小），丢弃：', currentC, '保留：', this.lastValidC)
          } else {
            this.serialDataC = currentC
            this.lastValidC = currentC
          }
        }
      }
      // 12秒没有新数据，速度置0
      this.serialTimeoutTimer = setTimeout(() => {
        // this.serialData = 0
        this.serialData = '--'
      }, 5000) // 12000

      console.log(this.serialData, '--------2')
    },
    getDate() {
      let date = new Date();
      let year = date.getFullYear(); // 年
      let month = date.getMonth() + 1; // 月
      let day = date.getDate(); // 日
      let hour = date.getHours(); // 时
      let week = date.getDay(); // 星期
      let weekArr = [ "星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六" ];
      hour = hour < 10 ? "0" + hour : hour; // 如果只有一位，则前面补零
      let minute = date.getMinutes(); // 分
      minute = minute < 10 ? "0" + minute : minute; // 如果只有一位，则前面补零
      let second = date.getSeconds(); // 秒
      second = second < 10 ? "0" + second : second; // 如果只有一位，则前面补零
      this.nowDate = `${hour}:${minute}:${second}`;
      this.nowDateList = `${year}.${month}.${day}`;
      // if (cookies.get('teamId') === '128812f8-354f-470f-b8fa-c33ff62b51d1') {
      //   this.formDate.date = this.nowDateList
      //   // this.getValue()
      // }
      this.nowDateWeek = `${weekArr[week]}`
    },
    getFormDate() {
      API.getDaPingJiTaiyinDu({deviceId: this.$route.query.deviceId}).then(res => {
        console.log(res)
        if (res.message.success) {
          this.formDate = res.message.data
          this.baseAllCount = res.message.data.allPrintCount || 0 // 保存基准
        }
        console.log(this.formDate)
      })
    },
    DaPingVersion() {
      API.getDaPingVersion({type:'YinDuShuiXiangShuJu'}).then(res =>{
        console.log(res,'---')
        // this.serverVersion = res.message.data

        const apiVer = Number(res.message.data)
        const localBaseVer = this.serverVersion
        console.log(apiVer,localBaseVer,'---')
        if (apiVer !== localBaseVer) {
          console.log(`版本不一致，基准:${localBaseVer} 接口返回:${apiVer}，准备清缓存刷新`)
          localStorage.setItem('lcd_server_version', apiVer)
          try {
            window.LcdBridge.clearCacheAndReload()
          } catch (e) {
            console.warn('LcdBridge调用失败，浏览器环境', e)
          }
        }
      })
    },
    currentTime(){
      setInterval(()=>{
        this.getDate()
      },1000)
    },
    currentTime2(){
      setInterval(()=>{
        this.getFormDate()
      },10000)
    },
  }
}
</script>

<style scoped lang="scss">
.container {
  width: 100%;
  height: 100vh;
  //overflow-y: auto;
}
.title {
  width: 100%;
  font-size: 55px;
  font-weight: bold;
  text-align: center;
  position: relative;
  //border-bottom: 1px solid #dcdddd;
  color: #222222;
  //background: -webkit-linear-gradient(#3268A6,#152E66);
  ////-webkit-background-clip: text;
  //-webkit-text-fill-color: transparent;
  line-height: 90px;
  background-image: url("~@/assets/img/monitor.png");
  background-size: 100% 100%;
  //background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  .title-center{
    background: -webkit-linear-gradient(#3268A6,#152E66);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
}
.equipment {
  position: absolute;
  color: #222222;
  font-size: 32px;
  top: -15px;
  left: 50px;
  display: flex;
  font-weight: normal;
  align-items: center;
  img {
    width: 24px;
    height: 24px;
    margin-right: 10px;
  }
}
.time {
  position: absolute;
  color: #222222;
  font-size: 32px;
  top: -15px;
  right: 15px;
  display: flex;
  font-weight: normal;
  align-items: center;
  img{
    width: 24px ;
    height: 24px;
    margin-right: 10px;
  }
}
.content-box {
  padding: 40px 30px 55px;
  display: flex;
  justify-content: space-between;
  gap: 30px;
  background: linear-gradient(180deg, #E9EFF5 0%, #E4EEFA 100%)
}
.left {
  padding: 50px 60px;
  background: linear-gradient(180deg, #C6DEFF 0%, #F2F7FE 100%);
  box-shadow: 0px 4px 5px 0px rgba(0, 0, 0, 0.1);
  border: 1.5px solid #FFFFFF;
  width: 63%;
  margin-right: 30px;
  .title {
    font-size: 50px;
    color: #222222;
    background-image:none;
    text-align: left;
    font-weight: normal;
  }
  .value {
    font-size: 292px;
    color: #146BF8;
    font-weight: bold;
    padding: 150px 0;
    text-align: center;
  }
}
.right {
  font-size: 52px;
  color: #222222;
}
.right-top {
  padding: 60px 50px;
  background: linear-gradient(180deg, #D7E8FF 0%, #F0F5FB 100%);
  box-shadow: 0px 4px 5px 0px rgba(0, 0, 0, 0.1);
  border: 1.5px solid #FFFFFF;
  gap: 50px;
  display: grid;
  margin-bottom: 30px;
  height: 48.3%;
  img{
    width: 45px;
    margin-right: 30px;
  }
  .right-item {
    display: flex;
    align-items: center;
    .ph{
      width: 300px;
      display: inline-block;
    }
    .value {
      width: 250px;
      text-align: right;
      color: #146BF8;
    }
  }
}
.right-top:last-child{
  margin-bottom: 0;
}
</style>
